<template>
    <div class="ticket-intro-fixed">
        <div class="container-fluid px-3">
            <div class="ticket-intro-fixed-inner">
                <div class="tl-wrapper">
                    <div class="tl-l">
                        <email-icon v-if="ticket.source == 'email'"></email-icon>
                        <email-icon v-if="ticket.source == 'urgent_email'"></email-icon>
                        <phone-icon v-if="ticket.source == 'phone'"></phone-icon>
                        <phone-icon v-if="ticket.source == 'emergency_phone'"></phone-icon>
                        <phone-icon v-if="ticket.source == 'whatsapp'"></phone-icon>
                    </div>
                    <div class="tl-r">
                        <h4>{{ ticket.subject }}</h4>
                    </div>
                    <div class="tl-badge" v-if="incidentReport">
                        <span class="incident-report-badge" @click="openIncidentReportSidebar">
                            <hazard-icon></hazard-icon>
                            <span class="badge-text">Incident Report</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PhoneIcon from '../../../../../components/icons/PhoneIcon.vue'
import EmailIcon from '../../../../../components/icons/EmailIcon.vue'
import HazardIcon from '../../../../../components/icons/HazardIcon.vue'

export default {
    components: {EmailIcon, PhoneIcon, HazardIcon},
    computed: {
        ...mapGetters('ticketViewer', {
            ticket: 'ticket',
            incidentReport: 'incidentReport'
        })
    },
    methods: {
        ...mapActions('ticketViewer', {
            setSidebarSection: 'setSidebarSection'
        }),
        
        openIncidentReportSidebar() {
            this.setSidebarSection('incident-report');
        }
    },
    created() {
    }
}
</script>

<style lang="scss" scoped>
.ticket-intro-fixed {
    position: sticky;
    left: 0;
    top: 0;
    right: 0;
    // border-bottom: 1px #cfd7df solid !important;
    // -webkit-box-shadow: 0 2px 4px 0 rgba(24, 50, 71, .08);
    // box-shadow: 0 2px 4px 0 rgba(24, 50, 71, .08);
    // height: 61px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(2px);
    z-index: 100;
    padding-top: 10px;
    padding-bottom: 10px;

    .ticket-intro-fixed-inner {
        // background: rgba(85, 110, 230, 0.25) !important;
        // background-image: linear-gradient(#e8f4f8, #e8f4f8);
        background-color: #f5f7f9;
        border-radius: 8px;
        padding: 11px 17px;
        border: 1px solid #cfd7df;

        h4 {
            margin-bottom: 0;
            font-size: 15px;
        }

        .tl-wrapper {
            display: flex;
            align-items: center;
            gap: 15px;
        }

        .tl-l {
            flex-shrink: 0;
        }

        .tl-r {
            display: flex;
            align-items: center;
            flex-grow: 1;
        }

        .tl-badge {
            flex-shrink: 0;
        }

        .incident-report-badge {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            background-color: #dc3545;
            color: white;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            cursor: pointer;
            transition: background-color 0.2s ease;

            &:hover {
                background-color: #c82333;
            }

            svg {
                width: 14px;
                height: 14px;
            }

            .badge-text {
                font-size: 11px;
            }
        }
    }
}
</style>